export default __webpack_public_path__ + "static/redLabelLogo-a31c92aa719810cc1c796f1806592c28.png";